import React from "react";
import "./footer.css";
import footerLogo from "../assets/images/Pillar-logo-text.png";
import { BsLinkedin } from "react-icons/bs";

export default function Footer() {
    return (
        <footer>

            <div className="footer-links">
                <ul className="footer-row">
                    <li><a className="footer-link" href="">Home</a></li>
                    <li><a className="footer-link" href="">Staffing</a></li>
                    <li><a className="footer-link" href="">Consulting</a></li>
                    <li><a className="footer-link" href="">Contact</a></li>
                </ul>
            
                <div className="footer-row footer-contact-row">
                    <p className="footer-contact-text">010 880 5211</p>
                    <p className="footer-contact-text">info@pillarsouthafrica.co.za</p>
                    <p className="footer-contact-text">resumes@pillarsouthafrica.co.za</p>
                    <p className="footer-contact-text">accounts@pillarsouthafrica.co.za</p>
                </div>
                <div className="footer-row">
                    <p className="gatsby-link">Powered by</p><a href="https://www.gatsbysoftworks.co.za" target="_blank" class="gatsby-link">Gatsby Softworks</a>
                </div>

            </div>

            <div className="footer-right">
                <div className="footer-logo-wrapper">

                </div>
                <div className="social-media-links">
                    <BsLinkedin size={30}/>
                </div>  
            </div>



        </footer>
    )  
}